
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class EstensioniGrid extends Serenity.EntityGrid<EstensioniRow, any> {
        protected getColumnsKey() { return EstensioniColumns.columnsKey; }
        protected getDialogType() { return EstensioniDialog; }
        protected getIdProperty() { return EstensioniRow.idProperty; }
        protected getInsertPermission() { return EstensioniRow.insertPermission; }
        protected getLocalTextPrefix() { return EstensioniRow.localTextPrefix; }
        protected getService() { return EstensioniService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}